<template>
  <div class="mobile-container">
    <!-- 手机顶部沉浸式状态栏 -->
    <!-- 磨砂渐变聊天顶部导航栏 -->
    <div class="chat-header">
      <div class="back-icon"></div>
      <div class="header-title">抖音会话</div>
      <div class="more-icon"></div>
    </div>

    <!-- 消息滚动区域 -->
    <div class="chat-main" ref="chatScroll">
      <div class="message-list">
        <div
            v-for="(msg, index) in validMessages"
            :key="msg.messageId + index"
            class="message-item"
        >
          <!-- 用户消息 role=1 左侧 -->
          <div v-if="msg.role === 1" class="msg-wrap user-wrap">
            <div class="avatar user-avatar">
              <img  @error="handleImgError"  :src="userAvatar" alt="用户头像" />
              <span class="text-avatar">用户</span>
            </div>
            <div class="bubble user-bubble">
              <div class="msg-text">{{ getMsgContent(msg) }}</div>
<!--              <div class="msg-time">{{ formatTime(msg.createTime) }}</div>-->
            </div>
          </div>

          <!-- 机器人开场白 role=3 右侧 -->
          <!-- AI客服回复 role=2 右侧 -->
          <div v-else-if="msg.role === 2 || msg.role === 3" class="msg-wrap bot-wrap">
            <div class="bubble bot-bubble">
              <div class="msg-text">{{ getMsgContent(msg) }}</div>
<!--              <div class="msg-time">{{ formatTime(msg.createTime) }}</div>-->
            </div>
            <div class="avatar bot-avatar">
              <img @error="handleImgError" :src="serviceAvatar" alt="客服头像" />
              <span class="text-avatar">客服</span>
            </div>
          </div>

          <!-- 系统通知 role=4 居中灰色提示 -->
          <div v-else-if="msg.role === 4" class="msg-wrap system-wrap">
            <div class="system-tip">{{ getMsgContent(msg) }}</div>
          </div>
        </div>

        <!-- 底部留白 -->
        <div class="bottom-space"></div>
      </div>
    </div>

    <!-- 毛玻璃底部输入栏 -->
    <div class="input-bar">
      <div class="input-box">
      </div>
      <!-- iPhone全面屏底部安全区 -->
      <div class="safe-area"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileChat",
  data() {
    return {
      chatData: {
        data: {
          msgs: [],
          customerAvatarUrl: "",
          clientAvatarUrl: ""
        }
      }
    };
  },
  computed: {
    validMessages() {
      return (this.chatData.data?.msgs || []).filter(item => {
        const text = this.getMsgContent(item);
        return text && text.trim().length > 0;
      });
    },
    userAvatar() {
      return this.chatData.data.clientAvatarUrl ;
    },
    serviceAvatar() {
      return this.chatData.data.customerAvatarUrl;
    }
  },
  mounted() {
    this.getChatData();
    this.scrollToBottom();
  },
  methods: {
    // 从URL获取sessionId
    getQueryString(name) {
      const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      const r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURIComponent(r[2]);
      return null;
    },

    async getChatData() {
      const sessionId = new URLSearchParams(window.location.search).get('sessionId');
      console.log("sessionId111")
      console.log(sessionId)
      console.log("1111111111111")
      if (!sessionId) return;
      console.log("22222")
      try {
        console.log("333")
        console.log(sessionId)
        const res = await fetch(`/api/getMsggBySessionId?sessionId=${sessionId}`);
        const result = await res.json();
        if (result.code === 200) {
          // 这里完全按你的接口结构赋值
          this.chatData.data.msgs = result.data.data.msgs;
          this.chatData.data.customerAvatarUrl = result.data.customerAvatarUrl;
          this.chatData.data.clientAvatarUrl = result.data.clientAvatarUrl;
          this.$nextTick(() => this.scrollToBottom());
        }
      } catch (err) {
        console.error("请求失败", err);
      }
    },

    handleImgError(e) {
      e.target.style.display = "none";
      e.target.nextElementSibling.style.display = "flex";
    },

    getMsgContent(msg) {
      if (msg.role === 1) {
        return Array.isArray(msg.inputs) && msg.inputs.length ? msg.inputs[0] : "";
      }
      if (msg.role === 2 || msg.role === 3) {
        return msg.reply || (Array.isArray(msg.inputs) && msg.inputs.length ? msg.inputs[0] : "");
      }
      if (msg.role === 4) {
        return Array.isArray(msg.inputs) && msg.inputs.length ? msg.inputs[0] : "";
      }
      return "";
    },

    // 时间格式化（已修复无报错）
    formatTime(timestamp) {
      if (!timestamp) return "";
      const date = new Date(Number(timestamp));
      const hour = date.getHours().toString().padStart(2, "0");
      const minute = date.getMinutes().toString().padStart(2, "0");
      return `${hour}:${minute}`;
    },

    scrollToBottom() {
      this.$nextTick(() => {
        const dom = this.$refs.chatScroll;
        if (dom) dom.scrollTop = dom.scrollHeight;
      });
    }
  },
  watch: {
    "chatData.data.msgs"() {
      this.scrollToBottom();
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif;
}

.mobile-container {
  max-width: 480px;
  margin: 0 auto;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(145deg, #f0f2f5, #e8ebf0);
  overflow: hidden;
}

.status-bar {
  height: 30px;
  background: transparent;
}

.chat-header {
  height: 48px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border-bottom: none;
}
.back-icon, .more-icon {
  font-size: 20px;
  color: #666;
  width: 32px;
  text-align: center;
  cursor: pointer;
}
.header-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  letter-spacing: 0.5px;
}

.chat-main {
  flex: 1;
  overflow-y: auto;
  padding: 16px 14px 0;
}
.message-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.message-item {
  width: 100%;
}

.msg-wrap {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  width: 100%;
}
.user-wrap {
  justify-content: flex-start;
}
.bot-wrap {
  justify-content: flex-end;
}
.system-wrap {
  justify-content: center;
  margin: 6px 0;
}
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  flex-shrink: 0;
  overflow: hidden;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.12);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
}
.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.text-avatar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #666;
  background: #e0e0e0;
}
.user-avatar .text-avatar {
  background: #dbe8ff;
  color: #4080ff;
}
.bot-avatar .text-avatar {
  background: #e3f5e5;
  color: #28c76f;
}
.bubble {
  max-width: 75%;
  padding: 13px 16px;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  position: relative;
  word-break: break-all;
  white-space: pre-wrap;
}
.user-bubble {
  background: #ffffff;
  border-radius: 20px 20px 20px 6px;
}
.bot-bubble {
  background: linear-gradient(135deg, #b6f599, #95EC69);
  border-radius: 20px 20px 6px 20px;
}

.msg-text {
  font-size: 15px;
  line-height: 1.6;
  color: #232323;
}
.msg-time {
  font-size: 11px;
  color: #aaa;
  text-align: right;
  margin-top: 5px;
  letter-spacing: 0.3px;
}

.system-tip {
  font-size: 12px;
  color: #888;
  background: rgba(0, 0, 0, 0.06);
  padding: 6px 16px;
  border-radius: 16px;
  backdrop-filter: blur(4px);
}

.bottom-space {
  height: 50px;
}

.input-bar {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  border-top: none;
}
.input-box {
  height: 54px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  gap: 12px;
}
.input {
  flex: 1;
  height: 38px;
  border-radius: 20px;
  border: none;
  padding: 0 18px;
  font-size: 15px;
  outline: none;
  background: rgba(240, 242, 245, 0.9);
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.08);
}
.send-btn {
  height: 38px;
  padding: 0 20px;
  border-radius: 20px;
  background: linear-gradient(135deg, #28c76f, #07C160);
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 3px 8px rgba(7, 193, 96, 0.25);
  cursor: pointer;
  transition: all 0.2s ease;
}
.send-btn:active {
  transform: scale(0.96);
}

.safe-area {
  height: 34px;
  background: #fff;
}

.chat-main::-webkit-scrollbar {
  width: 4px;
}
.chat-main::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 10px;
}
.chat-main::-webkit-scrollbar-track {
  background: transparent;
}
</style>